export const KEYS = {
  PLACE: 'PLACE',
  PLACE_ID: 'PLACE_ID',
  GAPI_REF: 'GAPI_REF',
  CATEGORIES: 'CATEGORIES',
  PRODUCTS: 'PRODUCTS',
  UPDATE_TIME: 'UPDATE_TIME',
}

const HOUR = 1000 * 60 * 60
export const STORAGE_PERIOD = HOUR * 24

export { StorageHandler } from './StorageHandler'
